(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/objectWithoutPropertiesLoose", "@h3yun/sdk-core", "@h3yun/request", "@h3yun/global-provider", "@h3yun-shared/utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/objectWithoutPropertiesLoose"), require("@h3yun/sdk-core"), require("@h3yun/request"), require("@h3yun/global-provider"), require("@h3yun-shared/utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.regenerator, global.asyncToGenerator, global.objectWithoutPropertiesLoose, global.sdkCore, global.request, global.globalProvider, global.utils);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _regenerator, _asyncToGenerator2, _objectWithoutPropertiesLoose2, _sdkCore, _request, _globalProvider, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports.appKey = appKey;
  _exports.engineKey = engineKey;
  _exports.schemaKey = schemaKey;
  _exports.userKey = userKey;
  _exports.viewKey = viewKey;
  _exports.viewModel = _exports.viewDefinition = _exports.userModel = _exports.userDefinition = _exports.schemaModel = _exports.schemaDefinition = _exports.middlewares = _exports.engineModel = _exports.engineDefinition = _exports.domainDefinitionMap = _exports.appModel = _exports.appDefinition = _exports.ViewScopeType = _exports.ViewContextImpl = _exports.UserContextImpl = _exports.SchemaContextImpl = _exports.FieldStatus = _exports.FieldPermissionTypeEnum = _exports.EngineState = _exports.EngineEntryType = _exports.EngineContextImpl = _exports.DomainStoreMap = _exports.DomainContextMap = _exports.AppPermissionEnum = _exports.AppContextImpl = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _request = _interopRequireDefault(_request);

  /**
   * @packageDocumentation
   * @module domain/user.actions
   */

  /**
   * @hidden
   */
  var userActionConfigs = (0, _sdkCore.actionConfig)({
    load: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    getEngines: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.engines;
      }
    },
    getUserInfo: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    updateUserInfo: {}
  });
  /**
   * @packageDocumentation
   * @module domain/user.model
   */

  var userModel = {
    userId: '',
    userName: '用户名',
    userAvatarUrl: '',
    userDescription: '个性签名',
    email: '',
    mobile: '',
    engines: []
  };
  /**
   * @packageDocumentation
   * @module domain/user.service
   */

  _exports.userModel = userModel;
  var userService = (0, _sdkCore.ModouService)({
    getUserEngine: function getUserEngine() {
      return _request["default"].get('/v1/corpintegrate/userengine', {
        remoteService: 'h3yun-corp-integrate-webapi'
      });
    },
    getMember: function getMember(memberId) {
      return _request["default"].get("/v1/org/member/" + memberId, {
        remoteService: 'h3yun-org-webapi'
      });
    },
    updateUserInfo: function updateUserInfo(data) {
      return (0, _request["default"])('/v1/user/information/basic/reset', {
        method: 'post',
        data: data
      });
    }
  });
  /**
   * 用户 User 模型定义
   * @packageDocumentation
   * @module domain/user
   */

  var userDefinition = (0, _sdkCore.defineDomain)({
    domainKey: 'User',
    actions: userActionConfigs,
    model: userModel,
    service: userService,
    globalOnly: true
  });
  /**
   * @hidden
   */

  _exports.userDefinition = userDefinition;

  function userKey() {
    return '';
  }
  /**
   * Engine Action
   * @packageDocumentation
   * @module domain/engine.actions
   */

  /**
   * @hidden
   */


  var engineActionConfigs = (0, _sdkCore.actionConfig)({
    load: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    setActiveEngine: {},
    getTodoTask: {},
    getApps: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.apps;
      }
    },
    getMyRoles: {},
    getAppByCode: {},
    createApp: {},
    updateApp: {},
    deleteApp: {},
    installApp: {},
    getMemberInfo: {},
    changeEngineActive: {},
    updateAppSorts: {},
    updateAppPreference: {},
    updateAppSortAndPreference: {},
    updateAppOwner: {},
    updatePreference: {},
    removeAppRoleByUser: {}
  });
  /**
   * Engine Action
   * @packageDocumentation
   * @module domain/engine.model
   */

  var EngineEntryType;
  _exports.EngineEntryType = EngineEntryType;

  (function (EngineEntryType) {
    EngineEntryType["DINGDING"] = "DINGDING";
    EngineEntryType["OWN"] = "OWN";
    EngineEntryType["UNKNOWN"] = "UNKNOWN";
  })(EngineEntryType || (_exports.EngineEntryType = EngineEntryType = {}));

  var EngineState;
  _exports.EngineState = EngineState;

  (function (EngineState) {
    EngineState["RUNNINE"] = "RUNNINE";
  })(EngineState || (_exports.EngineState = EngineState = {}));

  var engineModel = {
    code: '',
    corpId: '',
    corpName: '',
    engineCode: '',
    memberId: '',
    department: '',
    departmentId: '',
    entryType: EngineEntryType.UNKNOWN,
    lastActive: 20,
    state: EngineState.RUNNINE,
    apps: [],
    todoTask: {
      originated: 0,
      todo: 0
    },
    ownFlag: false,
    engineShard: ''
  };
  /**
   * Engine Action
   * @packageDocumentation
   * @module domain/engine.service
   */

  _exports.engineModel = engineModel;
  var engineService = (0, _sdkCore.ModouService)({
    getMemberInfo: function getMemberInfo(memberId) {
      return _request["default"].get("/v1/org/member/" + memberId, {
        remoteService: 'h3yun-org-webapi'
      });
    },
    getTodoTask: function getTodoTask() {
      return _request["default"].post('/v1/todo/count');
    },
    getApps: function getApps() {
      return _request["default"].get('/v1/app', {
        remoteService: 'h3yun-app-webapi'
      });
    },
    getMyRoles: function getMyRoles(memberId) {
      return _request["default"].get('/v1/role/user/all', {
        params: {
          memberId: memberId
        }
      });
    },
    createApp: function createApp(params) {
      return _request["default"].post('/v1/app', {
        data: params,
        remoteService: 'h3yun-app-webapi'
      });
    },
    changeEngine: function changeEngine(data) {
      return _request["default"].post('/v1/corpintegrate/corp/change', {
        remoteService: 'h3yun-corp-integrate-webapi',
        credentials: 'include',
        data: {
          fromCorpId: data.fromCorpId,
          fromCorpName: data.fromCorpName,
          fromEngineCode: data.fromEngineCode,
          fromMemberId: data.fromMemberId,
          toCorpId: data.toCorpId,
          toCorpName: data.toCorpName,
          toEngineCode: data.toEngineCode,
          toMemberId: data.toMemberId
        }
      });
    },
    updateAppSorts: function updateAppSorts(appCodes) {
      if (appCodes === void 0) {
        appCodes = [];
      }

      return _request["default"].post('/v1/preference/dashboard', {
        data: {
          key: 'appSorts',
          value: JSON.stringify(appCodes)
        }
      });
    },
    updateAppPreference: function updateAppPreference(appCodes) {
      if (appCodes === void 0) {
        appCodes = [];
      }

      return _request["default"].post('/v1/preference/dashboard', {
        data: {
          key: 'collectedApps',
          value: JSON.stringify(appCodes)
        }
      });
    },
    updateAppSortAndPreference: function updateAppSortAndPreference(items) {
      return _request["default"].post('/v1/preference/list/dashboard', {
        data: {
          items: {
            appSorts: items.appSorts || [],
            collectedApps: items.collectedApps || []
          }
        }
      });
    },

    /** 更新应用拥有者 */
    updateAppOwner: function updateAppOwner(data) {
      return _request["default"].post('/v1/role/changeappowner', {
        data: data
      });
    },
    removeAppRoleByUser: function removeAppRoleByUser(data) {
      return _request["default"].post(' /v1/role/userrole/delete/all', {
        data: data
      });
    }
  });
  /**
   * 引擎（团队）Engine 模型定义
   * @packageDocumentation
   * @module domain/engine
   */

  var engineDefinition = (0, _sdkCore.defineDomain)({
    domainKey: 'Engine',
    actions: engineActionConfigs,
    model: engineModel,
    service: engineService,
    globalOnly: true
  });
  /**
   * @hidden
   */

  _exports.engineDefinition = engineDefinition;

  function engineKey() {
    return '';
  }
  /**
   * @packageDocumentation
   * @module domain/app.actions
   */

  /**
   * @hidden
   */


  var appActionConfigs = (0, _sdkCore.actionConfig)({
    load: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    getAppInfo: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    getSchemas: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.schemas;
      }
    },
    getMyRoles: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.myRoles;
      }
    },
    getSchemaByCode: {},
    createSchema: {},
    addNewSchema: {},
    sortSchema: {},
    deleteSchema: {},
    updateApp: {},
    deleteApp: {},
    updateSchemaSharedState: {},
    createFunctionNode: {},
    deleteFunctionNode: {}
  });
  /**
   * @packageDocumentation
   * @module domain/app.model
   */

  var FieldPermissionTypeEnum;
  _exports.FieldPermissionTypeEnum = FieldPermissionTypeEnum;

  (function (FieldPermissionTypeEnum) {
    // 查看
    FieldPermissionTypeEnum["VISIBLE"] = "Visible"; // 编辑

    FieldPermissionTypeEnum["EDITABLE"] = "Editable";
  })(FieldPermissionTypeEnum || (_exports.FieldPermissionTypeEnum = FieldPermissionTypeEnum = {}));

  var AppPermissionEnum;
  _exports.AppPermissionEnum = AppPermissionEnum;

  (function (AppPermissionEnum) {
    // 拥有者
    AppPermissionEnum["OWNER"] = "OWNER"; // 管理员

    AppPermissionEnum["MANAGER"] = "MANAGER"; // 协作者

    AppPermissionEnum["COLLABORATORS"] = "COLLABORATORS"; // 访客

    AppPermissionEnum["VISITOR"] = "VISITOR"; // 游客

    AppPermissionEnum["GUEST"] = "GUEST";
  })(AppPermissionEnum || (_exports.AppPermissionEnum = AppPermissionEnum = {}));

  var appModel = {
    code: '',
    displayName: '',
    color: 0,
    ownerId: '',
    icon: '',
    modifiedTime: '',
    createTime: '',
    ownerName: '',
    createdBy: '',
    description: '',
    source: 0,
    schemas: [],
    isStoreUp: 0,
    sortIndex: 0,
    myRoles: [],
    mySuperRole: AppPermissionEnum.GUEST,
    permissions: {},
    schemaPermissions: {},
    fieldPermissions: {},
    activeModule: ''
  };
  /**
   * @packageDocumentation
   * @module domain/app.service
   */

  _exports.appModel = appModel;
  var appService = (0, _sdkCore.ModouService)({
    /**
     * 根据appCode获取应用信息
     * @param appCode 应用编码
     */
    getAppInfo: function getAppInfo(appCode) {
      return _request["default"].get("/v1/app/" + appCode);
    },

    /**
    * 根据appCode获取应用下的schema列表
    * @param appCode 应用编码
    */
    getSchemas: function getSchemas(appCode) {
      return _request["default"].get("/v1/app/node/" + appCode);
    },

    /**
     * 更新应用信息
     * @param params 应用数据
     */
    updateApp: function updateApp(params) {
      return _request["default"].put('/v1/app', {
        data: params
      });
    },
    deleteApp: function deleteApp(appCode) {
      return _request["default"]["delete"]("/v1/app/" + appCode);
    },
    createSchema: function createSchema(appParams) {
      return _request["default"].post('/v1/schema', {
        data: {
          appCode: appParams.appCode,
          displayName: appParams.displayName,
          isDashboard: appParams.isDashboard || false
        }
      });
    },
    sortSchema: function sortSchema(data) {
      var sortedCodes = data.sortedCodes;
      return _request["default"].post('/v1/app/sort', {
        data: sortedCodes
      });
    },
    getUserRoles: function getUserRoles(params) {
      return _request["default"].get('/v1/role/user/all', {
        params: params
      });
    },
    createFunctionNode: function createFunctionNode(param) {
      return _request["default"].post('/v1/functionnode', {
        data: param
      });
    },
    deleteFunctionNode: function deleteFunctionNode(code) {
      return _request["default"]["delete"]("/v1/functionnode/" + code);
    }
  });
  /**
   * 应用App 模型定义
   * @packageDocumentation
   * @module domain/app
   */

  /**
   * @hidden
   */

  var appDefinition = (0, _sdkCore.defineDomain)({
    domainKey: 'Apps',
    actions: appActionConfigs,
    model: appModel,
    service: appService,
    globalOnly: false
  });
  /**
   * @hidden
   */

  _exports.appDefinition = appDefinition;

  function appKey(scope, code) {
    return code;
  }
  /**
   * @packageDocumentation
   * @module domain/schema.actions
   */

  /**
   * @hidden
   */


  var schemaActionConfigs = (0, _sdkCore.actionConfig)({
    load: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    getFields: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.fields;
      }
    },
    getAccessPermissions: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.accessPermissions;
      }
    },
    getViews: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state.views;
      }
    },
    getViewByCode: {},
    getPreference: {},
    updatePreference: {},
    updateViewScopeType: {},
    createView: {},
    updateView: {},
    deleteView: {},
    updateSchema: {},
    deleteSchema: {},
    copySchema: {},
    getRecords: {},
    getRecordById: {},
    getFieldByCode: {},
    createField: {},
    updateField: {},
    deleteField: {},
    updateSharedState: {}
  });
  /**
   * @packageDocumentation
   * @module domain/schema.model
   */

  var FieldStatus;
  _exports.FieldStatus = FieldStatus;

  (function (FieldStatus) {
    FieldStatus[FieldStatus["Warning"] = 0] = "Warning";
    FieldStatus[FieldStatus["Normal"] = 1] = "Normal";
  })(FieldStatus || (_exports.FieldStatus = FieldStatus = {}));

  var schemaModel = {
    code: '',
    appCode: '',
    displayName: '',
    records: [],
    recordsCount: 0,
    sortKey: 0,
    type: 0,
    tag: 0,
    views: [],
    fields: [],
    accessPermissions: {},
    preference: {},
    isDashboard: false
  };
  /**
   * @packageDocumentation
   * @module domain/schema.service
   */

  _exports.schemaModel = schemaModel;
  var schemaService = (0, _sdkCore.ModouService)({
    updateSchema: function updateSchema(data) {
      var displayName = data.displayName,
          schemaCode = data.schemaCode,
          appCode = data.appCode,
          isDashboard = data.isDashboard;
      return _request["default"].put('/v1/schema', {
        data: {
          appCode: appCode,
          schemaCode: schemaCode,
          displayName: displayName,
          isDashboard: isDashboard
        }
      });
    },
    deleteSchema: function deleteSchema(schemaCode) {
      return _request["default"]["delete"]("/v1/schema/" + schemaCode);
    },
    copySchema: function copySchema(data) {
      return _request["default"].get("/v1/schema/copy/" + data.schemaCode + "/" + data.displayName);
    },
    getFieldsWithPermissions: function getFieldsWithPermissions(schemaCode, appCode) {
      return _request["default"].get("/v3/control/accessible/" + appCode + "/" + schemaCode);
    },
    getFields: function getFields(schemaCode) {
      return _request["default"].get("/v1/view/control/" + schemaCode);
    },
    getRecords: function getRecords(params) {
      var appCode = params.appCode,
          schemaCode = params.schemaCode,
          restParams = (0, _objectWithoutPropertiesLoose2["default"])(params, ["appCode", "schemaCode"]);
      return (0, _request["default"])("/v3/bizdata/query/" + appCode + "/" + schemaCode, {
        method: 'post',
        data: restParams
      });
    },
    createField: function createField(fieldParams) {
      var schemaCode = fieldParams.schemaCode,
          displayName = fieldParams.displayName,
          type = fieldParams.type,
          properties = fieldParams.properties,
          displayRule = fieldParams.displayRule,
          required = fieldParams.required,
          tips = fieldParams.tips;
      var data = {
        displayName: displayName,
        type: type,
        displayRule: displayRule,
        required: required,
        tips: tips,
        properties: properties
      };
      return (0, _request["default"])("/v2/view/control/" + schemaCode, {
        method: 'post',
        data: data
      });
    },
    updateField: function updateField(fieldParams) {
      var schemaCode = fieldParams.schemaCode,
          displayName = fieldParams.displayName,
          type = fieldParams.type,
          properties = fieldParams.properties,
          displayRule = fieldParams.displayRule,
          required = fieldParams.required,
          tips = fieldParams.tips,
          code = fieldParams.code;
      var data = {
        code: code,
        displayName: displayName,
        type: type,
        displayRule: displayRule,
        required: required,
        tips: tips,
        properties: properties
      };
      return (0, _request["default"])("/v1/view/control/" + schemaCode, {
        method: 'put',
        data: data
      });
    },
    deleteField: function deleteField(data) {
      var schemaCode = data.schemaCode,
          fieldCode = data.fieldCode;
      return (0, _request["default"])("/v1/view/control/" + schemaCode + "/" + fieldCode, {
        method: 'delete'
      });
    },
    getAccessPermissions: function getAccessPermissions(_ref) {
      var appCode = _ref.appCode,
          schemaCode = _ref.schemaCode;
      return _request["default"].get("/v1/rolepermission/accesspermission/user/" + appCode + "/" + schemaCode);
    },
    // getFieldPermissions () {
    // },
    getViews: function getViews(schemaCode) {
      return _request["default"].get("/v1/view/list/" + schemaCode);
    },
    getViewByCode: function getViewByCode(viewCode) {
      return _request["default"].get("/v1/view/" + viewCode);
    },
    createView: function createView(viewData) {
      return _request["default"].post('/v1/view', {
        data: viewData
      });
    },
    // updateView (viewData: Partial<View>) {
    //   return request.put<ModouResponse<boolean>>('/v1/view', {
    //     data: viewData,
    //   });
    // },
    updateView: function updateView(viewData) {
      return _request["default"].put('/v1/view/info', {
        data: viewData
      });
    },
    deleteView: function deleteView(schemaCode, viewCode) {
      return _request["default"]["delete"]("/v1/view/" + schemaCode + "/" + viewCode);
    },
    getPreference: function getPreference(schemaCode, memberId) {
      return _request["default"].get("/v1/preference/" + schemaCode + "/" + memberId);
    },
    updatePreference: function updatePreference(schemaCode, scope, setting) {
      var key = setting.key,
          value = setting.value;
      return (0, _request["default"])("/v1/preference/" + schemaCode, {
        method: 'post',
        data: {
          key: key,
          value: value,
          scope: scope
        }
      });
    },

    /**
    * 根据作用范围批量更新视图配置
    * @param schemaCode 数据表编码
    * @param scope 作用范围
    * @param settings 视图配置项
    */
    updateMultiPreference: function updateMultiPreference(schemaCode, scope, settings) {
      return (0, _request["default"])("/v1/preference/list/" + schemaCode, {
        method: 'post',
        data: {
          items: settings,
          scope: scope
        }
      });
    }
  });
  /**
   * 数据表 Schema 模型定义
   * @packageDocumentation
   * @module domain/schema
   */

  var schemaDefinition = (0, _sdkCore.defineDomain)({
    domainKey: 'Schemas',
    actions: schemaActionConfigs,
    model: schemaModel,
    service: schemaService,
    globalOnly: false
  });
  /**
   * @hidden
   */

  _exports.schemaDefinition = schemaDefinition;

  function schemaKey(scope, code) {
    return code;
  }
  /**
   * @packageDocumentation
   * @module domain/view.actions
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var viewActionConfigs = (0, _sdkCore.actionConfig)({
    load: {
      cacheable: true,
      cacheHandler: function cacheHandler(ctx) {
        return ctx.state;
      }
    },
    getViewConfig: {// cacheable: false,
      // cacheHandler: ctx => ctx.state.settings,
    },
    updateViewConfig: {}
  });
  /**
   * @packageDocumentation
   * @module domain/view.model
   */

  /**
   * 视图类型
   */

  var ViewScopeType;
  _exports.ViewScopeType = ViewScopeType;

  (function (ViewScopeType) {
    /** 公开视图 */
    ViewScopeType["PUBLIC"] = "public";
    /** 个人视图 */

    ViewScopeType["PERSONAL"] = "personal";
    /** 锁定视图 */

    ViewScopeType["LOCKED"] = "locked";
  })(ViewScopeType || (_exports.ViewScopeType = ViewScopeType = {}));
  /**
   * @packageDocumentation
   * @module domain/view.model
   */


  var viewModel = {
    code: '',
    schemaCode: '',
    appCode: '',
    displayName: '',
    layout: {},
    mode: '',
    settings: {},
    belongTo: '',
    type: ViewScopeType.PUBLIC,
    externalShortCode: ''
  };
  /**
   * @packageDocumentation
   * @module domain/view.service
   */

  _exports.viewModel = viewModel;
  var viewService = (0, _sdkCore.ModouService)({
    /**
     * 获取视图配置
     * @param params
     * @deprecated
     */
    getViewConfig: function getViewConfig(params) {
      return (0, _request["default"])("/v1/view/" + params.schemaCode + "/" + params.mode, {
        method: 'get'
      });
    },

    /**
     * 获取默认视图配置
     * @param schemaCode 数据表编码
     */
    getDefaultView: function getDefaultView(schemaCode) {
      return _request["default"].get("/v1/view/default/" + schemaCode);
    },

    /**
     * 更新视图配置
     * @param params 视图数据
     */
    updateViewConfig: function updateViewConfig(viewCode, settings) {
      // return request.put<ModouResponse<boolean>>('/v1/view', { data: params });
      return _request["default"].put("/v1/view/" + viewCode + "/setting", {
        data: settings
      });
    },

    /**
     * 获取偏好
     * @param params
     * @deprecated
     */
    getCustomSetting: function getCustomSetting(viewCode) {
      return (0, _request["default"])("/v1/preference/" + viewCode, {
        method: 'get'
      });
    },

    /**
     * 更新偏好
     * @param viewCode
     * @deprecated
     */
    updateCustomSetting: function updateCustomSetting(viewCode, setting) {
      return (0, _request["default"])("/v1/preference/" + viewCode, {
        method: 'post',
        data: setting
      });
    },

    /**
     * 根据作用范围获取视图配置
     * @param viewCode 视图编码
     * @param scope 作用范围
     */
    getPreference: function getPreference(viewCode, scope) {
      return _request["default"].get("/v1/preference/" + viewCode + "/" + scope);
    },

    /**
     * 根据作用范围更新视图配置
     * @param viewCode 视图编码
     * @param scope 作用范围
     * @param setting 视图配置项
     */
    updatePreference: function updatePreference(viewCode, scope, setting) {
      var key = setting.key,
          value = setting.value;
      return (0, _request["default"])("/v1/preference/" + viewCode, {
        method: 'post',
        data: {
          key: key,
          value: value,
          scope: scope
        }
      });
    },

    /**
     * 删除个性化视图配置
     * @param viewCode 视图编码
     * @returns 删除是否成功
     */
    removePreference: function removePreference(viewCode) {
      return _request["default"]["delete"]("/v1/preference/" + viewCode);
    },

    /**
     * 删除指定用户个性化视图配置
     * @param viewCode 视图编码
     * @param memberId 用户id
     * @returns 删除是否成功
     */
    removeUserPreference: function removeUserPreference(viewCode, memberId) {
      return _request["default"]["delete"]("/v1/preference/" + viewCode + "/" + memberId);
    },

    /**
     * 根据作用范围批量更新视图配置
     * @param viewCode 视图编码
     * @param scope 作用范围
     * @param settings 视图配置项
     */
    updateMultiPreference: function updateMultiPreference(viewCode, scope, settings) {
      return (0, _request["default"])("/v1/preference/list/" + viewCode, {
        method: 'post',
        data: {
          items: settings,
          scope: scope
        }
      });
    }
  });
  /**
   * 视图 View 模型定义
   * @packageDocumentation
   * @module domain/view
   */

  var viewDefinition = (0, _sdkCore.defineDomain)({
    domainKey: 'Views',
    actions: viewActionConfigs,
    model: viewModel,
    service: viewService,
    globalOnly: false
  });
  /**
   * @hidden
   */

  _exports.viewDefinition = viewDefinition;

  function viewKey(scope, code) {
    return code;
  }

  var activeLogMiddleware = function activeLogMiddleware(enabled, interval) {
    if (interval === void 0) {
      interval = 10000;
    }

    if (typeof window !== 'undefined') {
      var lastTimestamp = 0;
      return function (context, params, next) {
        if (enabled) {
          var now = getPfNow();
          var dltTime = now - lastTimestamp;

          if (dltTime > interval) {
            var scope = context.scope;
            var reportData = {};

            if (scope.AppContext.code) {
              reportData.appCode = scope.AppContext.code;
            }

            if (scope.SchemaContext.code) {
              reportData.schemaCode = scope.SchemaContext.code;
            }

            var lateinosFrontendReport = _globalProvider.globalStorage.get('lateinosFrontendReport');

            if (lateinosFrontendReport) {
              lateinosFrontendReport.reportKey('webactive', {
                eventKey: 'h3yun-web-active-event-v2',
                datas: [reportData]
              });
              lastTimestamp = now;
            }
          }
        }

        return next();
      };
    }

    return function (context, params, next) {
      return next();
    };
  };

  function getPfNow() {
    return window.performance.now ? window.performance.now() : Date.now();
  }

  var index = [// activeLogMiddleware(process.env.NODE_ENV === 'production', 5000),
  activeLogMiddleware(true, 10000)];
  _exports.middlewares = index;
  var AppPermissionEnum$1;

  (function (AppPermissionEnum) {
    // 拥有者
    AppPermissionEnum["OWNER"] = "OWNER"; // 管理员

    AppPermissionEnum["MANAGER"] = "MANAGER"; // 协作者

    AppPermissionEnum["COLLABORATORS"] = "COLLABORATORS"; // 访客

    AppPermissionEnum["VISITOR"] = "VISITOR"; // 游客

    AppPermissionEnum["GUEST"] = "GUEST";
  })(AppPermissionEnum$1 || (AppPermissionEnum$1 = {}));

  var roleTypeMap = {
    OWNER: {
      name: '拥有者',
      weight: 5
    },
    MANAGER: {
      name: '管理者',
      weight: 4
    },
    COLLABORATORS: {
      name: '协作者',
      weight: 3
    },
    VISITOR: {
      name: '访问者',
      weight: 2
    },
    GUEST: {
      name: '未分配权限',
      weight: 1
    },
    CUSTOM: {
      name: '',
      weight: 1
    }
  };
  var SchemaType;

  (function (SchemaType) {
    SchemaType[SchemaType["Normal"] = 0] = "Normal";
    SchemaType[SchemaType["SharedSchema"] = 1] = "SharedSchema";
    SchemaType[SchemaType["SyncSchema"] = 2] = "SyncSchema";
  })(SchemaType || (SchemaType = {}));
  /**
   * 将偏好转换为JSON字符串用于后端存储
   * @param preference
   */


  function convertPreferenceToJsonStr(preference) {
    var result = {};
    Object.entries(preference).forEach(function (_ref2) {
      var key = _ref2[0],
          value = _ref2[1];
      result[key] = JSON.stringify(value);
    });
    return result;
  }
  /**
   * 将偏好转换为JSON字符串用于后端存储
   * @param preference
   */


  function convertPreferenceToObject(preference) {
    var result = preference || {};

    for (var key in result) {
      if (typeof result[key] === 'string') {
        result[key] = (0, _utils.jsonParse)(result[key]) || (result[key] === 'false' ? false : null);
      }
    }

    return result;
  }
  /**
   * 判断是否是空对象
   * @param obj
   * @returns
   */


  function isEmptyObj(obj) {
    return !obj || Object.keys(obj).length === 0;
  }
  /**
   * 获取指定格式日期字符串
   * @param date 转换日期
   * @param format 格式字符串
   * @returns
   */


  function formatDate(date, format) {
    var fmt = format;
    var o = {
      "y+": date.getFullYear(),
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S": date.getMilliseconds() //毫秒 

    };

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }

    return fmt;
  }
  /**
   * 判断是空的时间字符串
   * @param dateString
   * @returns
   */


  function isEmptyDate(dateString) {
    return !dateString || dateString.startsWith('0001');
  }

  var app_context = {
    name: 'AppContext',
    domain: 'Apps',
    state: {},
    actions: {
      load: function load(context, appCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var res, currentApp;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  context.state.code = appCode;
                  _context.next = 3;
                  return context.scope.EngineContext.getAppByCode(appCode);

                case 3:
                  res = _context.sent;

                  if (!(!res.errorCode && res.data)) {
                    _context.next = 17;
                    break;
                  }

                  currentApp = res.data;
                  context.state.displayName = currentApp.displayName;
                  context.state.ownerId = currentApp.ownerId;
                  context.state.color = currentApp.color;
                  context.state.icon = currentApp.icon;
                  context.state.description = currentApp.description;
                  context.state.source = currentApp.source;
                  context.state.isStoreUp = currentApp.isStoreUp;
                  context.state.createTime = currentApp.createTime;
                  context.state.createdBy = currentApp.ownerName;
                  context.state.modifiedTime = isEmptyDate(currentApp.modifiedTime) ? currentApp.createTime : currentApp.modifiedTime;
                  return _context.abrupt("return", {
                    data: context.getValue()
                  });

                case 17:
                  return _context.abrupt("return", {
                    data: null,
                    errorCode: 'app-not-found',
                    errorMsg: '应用无权限或不存在',
                    errorType: 'BIZ'
                  });

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      getSchemas: function getSchemas(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var res;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return context.service.getSchemas(context.state.code);

                case 2:
                  res = _context2.sent;

                  if (res && !res.errorCode) {
                    context.state.schemas = res.data;
                  }

                  return _context2.abrupt("return", res);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      getSchemaByCode: function getSchemaByCode(context, schemaCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          var schema;
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return context.getSchemas();

                case 2:
                  _context3.next = 4;
                  return context.state.schemas.find(function (s) {
                    return s.code === schemaCode;
                  });

                case 4:
                  schema = _context3.sent;

                  if (!schema) {
                    _context3.next = 7;
                    break;
                  }

                  return _context3.abrupt("return", {
                    data: schema
                  });

                case 7:
                  return _context3.abrupt("return", {
                    errorCode: 'schema not found'
                  });

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      getMyRoles: function getMyRoles(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
          var memberId, res, roles, superRole;
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  memberId = context.scope.EngineContext.memberId; // 这里实际需要的是memberId

                  _context4.next = 3;
                  return context.service.getUserRoles({
                    appCode: context.state.code,
                    memberId: memberId
                  });

                case 3:
                  res = _context4.sent;

                  if (!(res && !res.errorCode && res.data.length > 0)) {
                    _context4.next = 11;
                    break;
                  }

                  roles = res.data || [];
                  superRole = convertSuperRole(roles);
                  context.state.myRoles = roles;
                  context.state.mySuperRole = convertSuperRole(roles); // 判断是否是管理员及以上

                  setPermissions(context.state, superRole);
                  return _context4.abrupt("return", {
                    data: roles
                  });

                case 11:
                  return _context4.abrupt("return", res);

                case 12:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      },
      createSchema: function createSchema(context, appParams) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return context.service.createSchema({
                    appCode: context.state.code,
                    displayName: appParams.displayName,
                    isDashboard: appParams.isDashboard || false
                  });

                case 2:
                  return _context5.abrupt("return", _context5.sent);

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      },
      sortSchema: function sortSchema(context, data) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
          var codes, newSchemas, schemas;
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  codes = Array.isArray(data.sortedCodes) ? data.sortedCodes : [];
                  newSchemas = [];
                  schemas = context.state.schemas;
                  codes.forEach(function (code) {
                    var schema = schemas.find(function (item) {
                      return item.code === code;
                    });
                    newSchemas.push(schema);
                  });
                  context.state.schemas = newSchemas;
                  _context6.next = 7;
                  return context.service.sortSchema(data);

                case 7:
                  return _context6.abrupt("return", _context6.sent);

                case 8:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))();
      },
      addNewSchema: function addNewSchema(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
          return _regenerator["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  context.state.schemas.push({
                    displayName: params.displayName,
                    code: params.code,
                    isNew: true,
                    isTabInputFocus: true,
                    type: params.type || 3,
                    tag: params.tag || 0
                  });
                  return _context7.abrupt("return", {
                    data: true
                  });

                case 2:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }))();
      },
      deleteSchema: function deleteSchema(context, schemaCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
          var schemas, res;
          return _regenerator["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  schemas = context.state.schemas;
                  _context8.next = 3;
                  return context.scope.SchemaContext.service.deleteSchema(schemaCode);

                case 3:
                  res = _context8.sent;

                  if (res && !res.errorCode && res.data) {
                    context.state.schemas = schemas.filter(function (schema) {
                      return schema.code !== schemaCode;
                    });
                  }

                  return _context8.abrupt("return", res);

                case 6:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }))();
      },
      updateApp: function updateApp(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
          var res, targetApp;
          return _regenerator["default"].wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  params.code = params.code || (context.state ? context.state.code : '');
                  _context9.next = 3;
                  return context.service.updateApp(params);

                case 3:
                  res = _context9.sent;

                  if (res && !res.errorCode && res.data) {
                    params.modifiedTime = formatDate(new Date(), 'yyyy-MM-dd hh:mm');
                    targetApp = context.rootState.Engine.apps.find(function (app) {
                      return app.code === params.code;
                    });
                    Object.assign(targetApp, params);

                    if (context.state && params.code === context.state.code) {
                      Object.assign(context.state, params);
                    }
                  }

                  return _context9.abrupt("return", res);

                case 6:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }))();
      },
      deleteApp: function deleteApp(context, appCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
          var code, res, _index;

          return _regenerator["default"].wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  code = appCode || context.state.code;
                  _context10.next = 3;
                  return context.service.deleteApp(code);

                case 3:
                  res = _context10.sent;

                  if (res && !res.errorCode && res.data) {
                    _index = context.rootState.Engine.apps.findIndex(function (app) {
                      return app.code === code;
                    });
                    context.rootState.Engine.apps.splice(_index, 1);
                  }

                  return _context10.abrupt("return", res);

                case 6:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }))();
      },
      updateSchemaSharedState: function updateSchemaSharedState(context, params) {
        var schemaCode = params.schemaCode,
            state = params.state;
        var schema = context.state.schemas.find(function (item) {
          return item.code === schemaCode;
        });
        schema.tag = state;
        schema.type = SchemaType.SharedSchema;
      },
      getTableSchemas: function getTableSchemas(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
          var res;
          return _regenerator["default"].wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return context.service.getSchemas(context.state.code);

                case 2:
                  res = _context11.sent;

                  if (res && !res.errorCode) {
                    context.state.schemas = res.data;
                  }

                  return _context11.abrupt("return", res);

                case 5:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }))();
      },
      getModules: function getModules(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
          var res;
          return _regenerator["default"].wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return context.service.getSchemas(context.state.code);

                case 2:
                  res = _context12.sent;

                  if (res && !res.errorCode) {
                    context.state.schemas = res.data;
                  }

                  return _context12.abrupt("return", res);

                case 5:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }))();
      },
      getActiveModule: function getActiveModule(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
          return _regenerator["default"].wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  return _context13.abrupt("return", context.scope.SchemaContext);

                case 1:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }))();
      },
      setActiveModule: function setActiveModule(context, schemaCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
          return _regenerator["default"].wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  context.state.activeModule = schemaCode;
                  return _context14.abrupt("return", context.scope.SchemaContext.load(schemaCode));

                case 2:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14);
        }))();
      },
      createFunctionNode: function createFunctionNode(context, param) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
          var res;
          return _regenerator["default"].wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 2;
                  return context.service.createFunctionNode({
                    appCode: context.state.code,
                    displayName: param.displayName,
                    type: param.type,
                    extendData: param.extendData
                  });

                case 2:
                  res = _context15.sent;
                  return _context15.abrupt("return", res);

                case 4:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15);
        }))();
      },
      deleteFunctionNode: function deleteFunctionNode(context, functionNodeCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
          var res, schemas;
          return _regenerator["default"].wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  _context16.next = 2;
                  return context.service.deleteFunctionNode(functionNodeCode);

                case 2:
                  res = _context16.sent;
                  schemas = context.state.schemas;

                  if (res && !res.errorCode && res.data) {
                    context.state.schemas = schemas.filter(function (schema) {
                      return schema.code !== functionNodeCode;
                    });
                  }

                  return _context16.abrupt("return", res);

                case 6:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16);
        }))();
      }
    }
  };
  _exports.AppContextImpl = app_context;

  function setPermissions(state, superRole) {
    var isManagerAbove = superRole === AppPermissionEnum.OWNER || superRole === AppPermissionEnum.MANAGER;
    state.permissions = {
      edit: isManagerAbove,
      "delete": superRole === AppPermissionEnum.OWNER,
      addMember: isManagerAbove,
      deleteMember: isManagerAbove,
      assignRole: isManagerAbove,
      exit: isManagerAbove,
      showWorkflow: isManagerAbove,
      addWorkflow: isManagerAbove,
      editWorkflow: isManagerAbove,
      deleteWorkflow: isManagerAbove
    };
    state.schemaPermissions = {
      add: isManagerAbove,
      edit: isManagerAbove,
      copy: isManagerAbove,
      sort: isManagerAbove,
      "delete": isManagerAbove
    };
    state.fieldPermissions = {
      add: isManagerAbove,
      edit: isManagerAbove,
      sort: isManagerAbove,
      "delete": isManagerAbove
    };
  }

  function convertSuperRole(roles) {
    var superRole = AppPermissionEnum.GUEST;

    if (roles.length) {
      var targetWeight = roleTypeMap[superRole].weight;

      for (var i = 0; i < roles.length; i++) {
        var item = roles[i].name || AppPermissionEnum.GUEST;
        var curWeight = roleTypeMap[item].weight || roleTypeMap.GUEST.weight;

        if (curWeight > targetWeight) {
          targetWeight = curWeight;
        }
      }

      for (var key in roleTypeMap) {
        var weight = roleTypeMap[key].weight;

        if (weight === targetWeight) {
          superRole = key;
          break;
        }
      }
    }

    return superRole;
  }

  var engine_context = {
    name: 'EngineContext',
    domain: 'Engine',
    state: {},
    actions: {
      load: function load(context, engineCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
          var enginesRes, engines, currentEngine;
          return _regenerator["default"].wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  if (engineCode === void 0) {
                    engineCode = '';
                  }

                  _context17.next = 3;
                  return context.scope.UserContext.getEngines();

                case 3:
                  enginesRes = _context17.sent;

                  if (!(enginesRes && !enginesRes.errorCode)) {
                    _context17.next = 8;
                    break;
                  }

                  engines = enginesRes.data;

                  if (engines.length > 0) {
                    currentEngine = engines.find(function (engine) {
                      return engine.lastActive === 10;
                    }) || engines[0];
                    context.state.code = currentEngine.engineCode;
                    context.state.engineCode = currentEngine.engineCode;
                    context.state.corpId = currentEngine.corpId;
                    context.state.corpName = currentEngine.corpName;
                    context.state.memberId = currentEngine.memberId;
                    context.state.entryType = currentEngine.entryType;
                    context.state.lastActive = currentEngine.lastActive;
                    context.state.ownFlag = currentEngine.ownFlag;
                    context.state.engineShard = currentEngine.engineShard;
                  }

                  return _context17.abrupt("return", {
                    data: context.getValue()
                  });

                case 8:
                  return _context17.abrupt("return", {
                    errorCode: enginesRes.errorCode,
                    data: context.getValue()
                  });

                case 9:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17);
        }))();
      },
      getApps: function getApps(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
          var res;
          return _regenerator["default"].wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.next = 2;
                  return context.service.getApps();

                case 2:
                  res = _context18.sent;

                  if (res && !res.errorCode) {
                    context.state.apps = res.data.map(function (app) {
                      return (0, _extends2["default"])({}, app, {
                        modifiedTime: isEmptyDate(app.modifiedTime) ? app.createTime : app.modifiedTime
                      });
                    });
                  }

                  return _context18.abrupt("return", res);

                case 5:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }))();
      },
      getAppByCode: function getAppByCode(context, appCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
          var app;
          return _regenerator["default"].wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _context19.next = 2;
                  return context.getApps();

                case 2:
                  app = context.state.apps.find(function (a) {
                    return a.code === appCode;
                  });

                  if (!app) {
                    _context19.next = 5;
                    break;
                  }

                  return _context19.abrupt("return", {
                    data: app
                  });

                case 5:
                  return _context19.abrupt("return", {
                    errorCode: 'app not found'
                  });

                case 6:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19);
        }))();
      },
      createApp: function createApp(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
          var res, appCode, resA, list, app;
          return _regenerator["default"].wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  _context20.next = 2;
                  return context.service.createApp(params);

                case 2:
                  res = _context20.sent;

                  if (!(res && !res.errorCode)) {
                    _context20.next = 9;
                    break;
                  }

                  appCode = res.data;
                  _context20.next = 7;
                  return context.service.getApps();

                case 7:
                  resA = _context20.sent;

                  if (resA && !resA.errorCode) {
                    list = resA.data || [];
                    app = list.find(function (val) {
                      return val.code === appCode;
                    });
                    app && context.state.apps.unshift(app);
                  }

                case 9:
                  return _context20.abrupt("return", res);

                case 10:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20);
        }))();
      },
      installApp: function installApp(context, app) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
          return _regenerator["default"].wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  if (app && app.code) {
                    context.state.apps.unshift(app);
                  }

                  return _context21.abrupt("return", {
                    data: true
                  });

                case 2:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21);
        }))();
      },
      getTodoTask: function getTodoTask(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
          var res;
          return _regenerator["default"].wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  _context22.next = 2;
                  return context.service.getTodoTask();

                case 2:
                  res = _context22.sent;

                  if (res && !res.errorCode) {
                    context.state.todoTask = {
                      originated: res.data.originated,
                      todo: res.data.todo
                    };
                  }

                  return _context22.abrupt("return", res);

                case 5:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22);
        }))();
      },
      getMemberInfo: function getMemberInfo(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
          var res, member;
          return _regenerator["default"].wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  _context23.next = 2;
                  return context.service.getMemberInfo(context.state.memberId);

                case 2:
                  res = _context23.sent;

                  if (res && !res.errorCode) {
                    member = res.data;
                    context.state.department = member.department || '';
                    context.state.departmentId = member.departmentId || '';
                  }

                  return _context23.abrupt("return", res);

                case 5:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23);
        }))();
      },
      // 获取当前用户下所有app的权限列表
      getMyRoles: function getMyRoles(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24() {
          var id, res;
          return _regenerator["default"].wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  id = context.state.memberId;
                  _context24.next = 3;
                  return context.service.getMyRoles(id);

                case 3:
                  res = _context24.sent;
                  return _context24.abrupt("return", res);

                case 5:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24);
        }))();
      },
      // 变更当前激活的Engine
      changeEngineActive: function changeEngineActive(_ref3, targetEngine) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25() {
          var service, state, res;
          return _regenerator["default"].wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  service = _ref3.service, state = _ref3.state;
                  _context25.next = 3;
                  return service.changeEngine({
                    fromCorpId: state.corpId,
                    fromCorpName: state.corpName,
                    fromEngineCode: state.engineCode,
                    fromMemberId: state.memberId,
                    toCorpId: targetEngine.corpId,
                    toCorpName: targetEngine.corpName,
                    toEngineCode: targetEngine.engineCode,
                    toMemberId: targetEngine.memberId
                  });

                case 3:
                  res = _context25.sent;

                  if (res && !res.errorCode && res.data) {
                    state.corpId = targetEngine.corpId;
                    state.corpName = targetEngine.corpName;
                    state.engineCode = targetEngine.engineCode;
                    state.memberId = targetEngine.memberId;
                  }

                  return _context25.abrupt("return", res);

                case 6:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25);
        }))();
      },
      updateAppSorts: function updateAppSorts(_ref4, appCodes) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26() {
          var service, state, res, apps;
          return _regenerator["default"].wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  service = _ref4.service, state = _ref4.state;
                  _context26.next = 3;
                  return service.updateAppSorts(appCodes);

                case 3:
                  res = _context26.sent;
                  apps = [];
                  appCodes.forEach(function (str) {
                    var app = state.apps.find(function (item) {
                      return item.code === str;
                    });
                    apps.push(app);
                  });
                  state.apps = apps;
                  return _context26.abrupt("return", res);

                case 8:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26);
        }))();
      },
      updateAppPreference: function updateAppPreference(context, appCodes) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27() {
          var res, state;
          return _regenerator["default"].wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  _context27.next = 2;
                  return context.service.updateAppPreference(appCodes);

                case 2:
                  res = _context27.sent;
                  state = context.state;
                  state.apps.forEach(function (item) {
                    item.isStoreUp = appCodes.includes(item.code) ? 1 : 0;
                  });
                  return _context27.abrupt("return", res);

                case 6:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee27);
        }))();
      },
      updateAppSortAndPreference: function updateAppSortAndPreference(context, _ref5) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28() {
          var appSorts, collectedApps, res, state, apps;
          return _regenerator["default"].wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  appSorts = _ref5.appSorts, collectedApps = _ref5.collectedApps;
                  _context28.next = 3;
                  return context.service.updateAppSortAndPreference({
                    appSorts: appSorts,
                    collectedApps: collectedApps
                  });

                case 3:
                  res = _context28.sent;
                  state = context.state;
                  apps = [];
                  appSorts.forEach(function (str) {
                    var app = state.apps.find(function (item) {
                      return item.code === str;
                    });
                    apps.push(app);
                  });
                  apps.forEach(function (item) {
                    item.isStoreUp = collectedApps.includes(item.code) ? 1 : 0;
                  });
                  state.apps = apps;
                  return _context28.abrupt("return", res);

                case 10:
                case "end":
                  return _context28.stop();
              }
            }
          }, _callee28);
        }))();
      },
      // 更新应用的拥有者
      updateAppOwner: function updateAppOwner(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29() {
          var res;
          return _regenerator["default"].wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  _context29.next = 2;
                  return context.service.updateAppOwner(params);

                case 2:
                  res = _context29.sent;
                  return _context29.abrupt("return", res);

                case 4:
                case "end":
                  return _context29.stop();
              }
            }
          }, _callee29);
        }))();
      },
      // 退出指定应用
      removeAppRoleByUser: function removeAppRoleByUser(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30() {
          var res, _index2;

          return _regenerator["default"].wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  _context30.next = 2;
                  return context.service.removeAppRoleByUser(params);

                case 2:
                  res = _context30.sent;

                  if (res && !res.errorCode && res.data) {
                    _index2 = context.rootState.Engine.apps.findIndex(function (app) {
                      return app.code === params.appCode;
                    });
                    context.rootState.Engine.apps.splice(_index2, 1);
                  }

                  return _context30.abrupt("return", res);

                case 5:
                case "end":
                  return _context30.stop();
              }
            }
          }, _callee30);
        }))();
      }
    }
  }; // 获取公开的viewsetting

  _exports.EngineContextImpl = engine_context;

  function getPublicViewSetting(_x, _x2) {
    return _getPublicViewSetting.apply(this, arguments);
  }

  function _getPublicViewSetting() {
    _getPublicViewSetting = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee60(viewCode, scope) {
      var res;
      return _regenerator["default"].wrap(function _callee60$(_context60) {
        while (1) {
          switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return scope.SchemaContext.getViewByCode(viewCode);

            case 2:
              res = _context60.sent;

              if (!(res && res.data && !res.errorCode)) {
                _context60.next = 5;
                break;
              }

              return _context60.abrupt("return", {
                data: res.data.settings
              });

            case 5:
              return _context60.abrupt("return", res);

            case 6:
            case "end":
              return _context60.stop();
          }
        }
      }, _callee60);
    }));
    return _getPublicViewSetting.apply(this, arguments);
  }

  function getPreference(_x3, _x4, _x5) {
    return _getPreference.apply(this, arguments);
  } // 带业务的获取视图配置（管理员直接获取全局视图配置， 非管理员获取个性化配置）


  function _getPreference() {
    _getPreference = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee61(viewCode, memberId, scope) {
      var res, result;
      return _regenerator["default"].wrap(function _callee61$(_context61) {
        while (1) {
          switch (_context61.prev = _context61.next) {
            case 0:
              _context61.next = 2;
              return scope.ViewContext.service.getPreference(viewCode, memberId);

            case 2:
              res = _context61.sent;

              if (!(res && !res.errorCode)) {
                _context61.next = 6;
                break;
              }

              // const result = convertPreferenceToObject(res.data || {});
              result = res.data || {};
              return _context61.abrupt("return", {
                data: result
              });

            case 6:
              return _context61.abrupt("return", {
                errorCode: 'viewType not exists',
                data: null
              });

            case 7:
            case "end":
              return _context61.stop();
          }
        }
      }, _callee61);
    }));
    return _getPreference.apply(this, arguments);
  }

  var getViewSetting = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31(viewCode, memberId, scope) {
      var view, type, superRole, ret;
      return _regenerator["default"].wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return scope.SchemaContext.getViewByCode(viewCode);

            case 2:
              view = _context31.sent;

              if (!view.errorCode) {
                _context31.next = 5;
                break;
              }

              return _context31.abrupt("return", view);

            case 5:
              type = view.data.type;

              if (!(type === ViewScopeType.PUBLIC || type === ViewScopeType.LOCKED)) {
                _context31.next = 20;
                break;
              }

              // 这里普通用户可能会多存在preference, 管理员只存viewsetting,且只从viewsetting取
              superRole = scope.AppContext.mySuperRole;

              if (!(superRole === AppPermissionEnum.MANAGER || superRole === AppPermissionEnum.OWNER || type === ViewScopeType.LOCKED)) {
                _context31.next = 12;
                break;
              }

              return _context31.abrupt("return", getPublicViewSetting(viewCode, scope));

            case 12:
              _context31.next = 14;
              return getPreference(viewCode, memberId, scope);

            case 14:
              ret = _context31.sent;

              if (!(!ret.errorCode && (!ret.data || isEmptyObj(ret.data)))) {
                _context31.next = 17;
                break;
              }

              return _context31.abrupt("return", getPublicViewSetting(viewCode, scope));

            case 17:
              return _context31.abrupt("return", ret);

            case 18:
              _context31.next = 22;
              break;

            case 20:
              if (!(type === ViewScopeType.PERSONAL)) {
                _context31.next = 22;
                break;
              }

              return _context31.abrupt("return", getPreference(viewCode, memberId, scope));

            case 22:
              return _context31.abrupt("return", {
                errorCode: 'viewType not exists',
                data: null
              });

            case 23:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    return function getViewSetting(_x6, _x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();

  var schema_context = {
    name: 'SchemaContext',
    domain: 'Schemas',
    state: {},
    actions: {
      load: function load(context, code) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee32() {
          var res, targetSchema;
          return _regenerator["default"].wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  context.state.code = code;
                  context.state.appCode = context.scope.AppContext.code;
                  _context32.next = 4;
                  return context.scope.AppContext.getSchemaByCode(code);

                case 4:
                  res = _context32.sent;

                  if (!(res && !res.errorCode)) {
                    _context32.next = 9;
                    break;
                  }

                  targetSchema = res.data;

                  if (targetSchema) {
                    context.state.displayName = targetSchema.displayName;
                    context.state.type = targetSchema.type;
                    context.state.tag = targetSchema.tag;
                  }

                  return _context32.abrupt("return", {
                    data: context.getValue()
                  });

                case 9:
                  return _context32.abrupt("return", res);

                case 10:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32);
        }))();
      },
      getFields: function getFields(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee33() {
          var ignorePermissions, appCode, res;
          return _regenerator["default"].wrap(function _callee33$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  ignorePermissions = params ? params.ignorePermissions : false;
                  appCode = context.scope.AppContext.code;

                  if (!ignorePermissions) {
                    _context33.next = 8;
                    break;
                  }

                  _context33.next = 5;
                  return context.service.getFields(context.state.code);

                case 5:
                  res = _context33.sent;
                  _context33.next = 11;
                  break;

                case 8:
                  _context33.next = 10;
                  return context.service.getFieldsWithPermissions(context.state.code, appCode);

                case 10:
                  res = _context33.sent;

                case 11:
                  if (res && !res.errorCode) {
                    context.state.fields = res.data;
                  }

                  return _context33.abrupt("return", res);

                case 13:
                case "end":
                  return _context33.stop();
              }
            }
          }, _callee33);
        }))();
      },
      getFieldByCode: function getFieldByCode(context, fieldCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee34() {
          var res, fields;
          return _regenerator["default"].wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  _context34.next = 2;
                  return context.getFields();

                case 2:
                  res = _context34.sent;

                  if (!(res && !res.errorCode)) {
                    _context34.next = 6;
                    break;
                  }

                  fields = res.data;
                  return _context34.abrupt("return", {
                    data: fields.find(function (field) {
                      return fieldCode === field.code;
                    })
                  });

                case 6:
                  return _context34.abrupt("return", {
                    data: null
                  });

                case 7:
                case "end":
                  return _context34.stop();
              }
            }
          }, _callee34);
        }))();
      },
      getAccessPermissions: function getAccessPermissions(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee35() {
          var state, targetSchemaCode, targetAppCode, userId, res, accessPermissions;
          return _regenerator["default"].wrap(function _callee35$(_context35) {
            while (1) {
              switch (_context35.prev = _context35.next) {
                case 0:
                  state = context.state;
                  targetSchemaCode = state.code;
                  targetAppCode = context.scope.AppContext.code;
                  userId = context.scope.EngineContext.memberId; // 这里实际需要的是memberId

                  _context35.next = 6;
                  return context.service.getAccessPermissions({
                    appCode: targetAppCode,
                    userId: userId,
                    schemaCode: targetSchemaCode
                  });

                case 6:
                  res = _context35.sent;

                  if (res && !res.errorCode && res.data) {
                    accessPermissions = res.data;

                    if (accessPermissions) {
                      state.accessPermissions.add = accessPermissions.Add || false;
                      state.accessPermissions["delete"] = accessPermissions.Delete || false;
                      state.accessPermissions.batchDelete = accessPermissions.BatchDelete || false;
                      state.accessPermissions.batchEdit = accessPermissions.BatchUpdate || false;
                      state.accessPermissions["import"] = accessPermissions.Import || false;
                      state.accessPermissions["export"] = accessPermissions.Export || false;
                      state.accessPermissions.share = accessPermissions.Share || false;
                    }
                  }

                  return _context35.abrupt("return", res);

                case 9:
                case "end":
                  return _context35.stop();
              }
            }
          }, _callee35);
        }))();
      },
      getRecords: function getRecords(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee36() {
          var fields, filters, filterItems, sorts, res;
          return _regenerator["default"].wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  /**
                   * 2020-12-28 guosha
                   * 对筛选排序做过滤处理，清除被删除，被控件转换的控件
                   */
                  fields = context.state.fields; // 筛选类型由一维更新为二维数组，对旧数据做一次兼容

                  filters = Array.isArray(params.filterItems) ? Array.isArray(params.filterItems[0]) ? params.filterItems[0] : params.filterItems : [];
                  filterItems = filters.filter(function (control) {
                    return control.code === 'ParentObjectId' || fields.find(function (item) {
                      // 电话、邮箱、身份证、关联取targetType
                      var type = item.properties.targetType || item.type;
                      return control.code === item.code && control.controlType === type;
                    });
                  });
                  sorts = (params.sorts || []).filter(function (control) {
                    return fields.find(function (item) {
                      return control.code === item.code;
                    });
                  });
                  _context36.next = 6;
                  return context.service.getRecords((0, _extends2["default"])({}, params, {
                    filterItems: [filterItems],
                    sorts: sorts
                  }));

                case 6:
                  res = _context36.sent;

                  if (res && !res.errorCode) {
                    context.state.recordsCount = res.data ? res.data.total : 0;
                  }

                  return _context36.abrupt("return", res);

                case 9:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36);
        }))();
      },
      updateSchema: function updateSchema(context, data) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee37() {
          var appCode, res, _context$rootState$Ap, targetSchema;

          return _regenerator["default"].wrap(function _callee37$(_context37) {
            while (1) {
              switch (_context37.prev = _context37.next) {
                case 0:
                  appCode = context.scope.AppContext.code;
                  _context37.next = 3;
                  return context.service.updateSchema({
                    appCode: appCode,
                    schemaCode: data.schemaCode,
                    displayName: data.displayName
                  });

                case 3:
                  res = _context37.sent;

                  if (res && !res.errorCode && res.data) {
                    // context.state.displayName = data.displayName;
                    // context.state.code = ;
                    targetSchema = (_context$rootState$Ap = context.rootState.Apps[appCode]) == null ? void 0 : _context$rootState$Ap.schemas.find(function (schema) {
                      return schema.code === data.schemaCode;
                    });
                    targetSchema.displayName = data.displayName;

                    if ('isNew' in targetSchema) {
                      delete targetSchema.isNew;
                    }
                  }

                  return _context37.abrupt("return", res);

                case 6:
                case "end":
                  return _context37.stop();
              }
            }
          }, _callee37);
        }))();
      },
      deleteSchema: function deleteSchema(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee38() {
          var schemaCode, res;
          return _regenerator["default"].wrap(function _callee38$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  schemaCode = context.state.code;
                  _context38.next = 3;
                  return context.service.deleteSchema(schemaCode);

                case 3:
                  res = _context38.sent;
                  if (res && !res.errorCode) ;
                  return _context38.abrupt("return", res);

                case 6:
                case "end":
                  return _context38.stop();
              }
            }
          }, _callee38);
        }))();
      },
      createField: function createField(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee39() {
          var schemaCode, res, newField;
          return _regenerator["default"].wrap(function _callee39$(_context39) {
            while (1) {
              switch (_context39.prev = _context39.next) {
                case 0:
                  schemaCode = context.state.code;
                  params.schemaCode = schemaCode;
                  _context39.next = 4;
                  return context.service.createField(params);

                case 4:
                  res = _context39.sent;

                  if (res && !res.errorCode && res.data) {
                    newField = Object.assign({}, params, res.data);
                    context.state.fields.push(newField);
                  }

                  return _context39.abrupt("return", res);

                case 7:
                case "end":
                  return _context39.stop();
              }
            }
          }, _callee39);
        }))();
      },
      updateField: function updateField(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee40() {
          var res, field;
          return _regenerator["default"].wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  params.schemaCode = params.schemaCode || context.state.code;
                  _context40.next = 3;
                  return context.service.updateField(params);

                case 3:
                  res = _context40.sent;

                  if (res && !res.errorCode) {
                    field = context.state.fields.find(function (cur) {
                      return cur.code === params.code;
                    });

                    if (field) {
                      params.displayName && (field.displayName = params.displayName);
                      params.displayRule && (field.displayRule = params.displayRule);
                      params.properties && (field.properties = params.properties);
                      params.required !== undefined && (field.required = params.required);
                      params.tips && (field.tips = params.tips);
                      params.type && (field.type = params.type);
                    }
                  }

                  return _context40.abrupt("return", res);

                case 6:
                case "end":
                  return _context40.stop();
              }
            }
          }, _callee40);
        }))();
      },
      deleteField: function deleteField(context, fieldCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee41() {
          var schemaCode, res;
          return _regenerator["default"].wrap(function _callee41$(_context41) {
            while (1) {
              switch (_context41.prev = _context41.next) {
                case 0:
                  schemaCode = context.state.code;
                  _context41.next = 3;
                  return context.service.deleteField({
                    schemaCode: schemaCode,
                    fieldCode: fieldCode
                  });

                case 3:
                  res = _context41.sent;

                  if (res && !res.errorCode && res.data) {
                    context.state.fields = context.state.fields.filter(function (cur) {
                      return cur.code !== fieldCode;
                    });
                  }

                  return _context41.abrupt("return", res);

                case 6:
                case "end":
                  return _context41.stop();
              }
            }
          }, _callee41);
        }))();
      },
      copySchema: function copySchema(context, _ref7) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee42() {
          var displayName, schemaCode, res;
          return _regenerator["default"].wrap(function _callee42$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  displayName = _ref7.displayName;
                  schemaCode = context.state.code;
                  _context42.next = 4;
                  return context.service.copySchema({
                    displayName: displayName,
                    schemaCode: schemaCode
                  });

                case 4:
                  res = _context42.sent;
                  if (res && !res.errorCode) ;
                  return _context42.abrupt("return", res);

                case 7:
                case "end":
                  return _context42.stop();
              }
            }
          }, _callee42);
        }))();
      },
      getViews: function getViews(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee43() {
          var schemaCode, _yield$Promise$all, res, preferenceRes, views, viewSorts;

          return _regenerator["default"].wrap(function _callee43$(_context43) {
            while (1) {
              switch (_context43.prev = _context43.next) {
                case 0:
                  schemaCode = context.state.code;
                  _context43.next = 3;
                  return Promise.all([context.service.getViews(schemaCode), context.getPreference()]);

                case 3:
                  _yield$Promise$all = _context43.sent;
                  res = _yield$Promise$all[0];
                  preferenceRes = _yield$Promise$all[1];

                  if (!res.errorCode) {
                    views = res.data;

                    if (!preferenceRes.errorCode) {
                      viewSorts = preferenceRes.data && preferenceRes.data.viewSorts;

                      if (viewSorts) {
                        views = sortViewByPreference(views, viewSorts);
                      }
                    }

                    context.state.views = views;
                  }

                  return _context43.abrupt("return", res);

                case 8:
                case "end":
                  return _context43.stop();
              }
            }
          }, _callee43);
        }))();
      },
      getViewByCode: function getViewByCode(context, viewCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee44() {
          var res, currentView;
          return _regenerator["default"].wrap(function _callee44$(_context44) {
            while (1) {
              switch (_context44.prev = _context44.next) {
                case 0:
                  _context44.next = 2;
                  return context.getViews();

                case 2:
                  res = _context44.sent;

                  if (!(!res.errorCode && res.data.length > 0)) {
                    _context44.next = 7;
                    break;
                  }

                  currentView = context.state.views.find(function (view) {
                    return view.viewCode === viewCode;
                  });

                  if (!currentView) {
                    _context44.next = 7;
                    break;
                  }

                  return _context44.abrupt("return", {
                    data: currentView
                  });

                case 7:
                  return _context44.abrupt("return", {
                    errorCode: res.errorCode || 'view not found',
                    errorMsg: res.errorMsg || 'view not found',
                    data: undefined,
                    errorType: res.errorType
                  });

                case 8:
                case "end":
                  return _context44.stop();
              }
            }
          }, _callee44);
        }))();
      },
      createView: function createView(context, viewData) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee45() {
          var res, newView;
          return _regenerator["default"].wrap(function _callee45$(_context45) {
            while (1) {
              switch (_context45.prev = _context45.next) {
                case 0:
                  _context45.next = 2;
                  return context.service.createView(viewData);

                case 2:
                  res = _context45.sent;

                  if (!res.errorCode) {
                    newView = (0, _extends2["default"])({
                      code: res.data,
                      viewCode: res.data
                    }, viewData);
                    newView.type = newView.type || ViewScopeType.PERSONAL;
                    context.state.views.push(newView);
                  }

                  return _context45.abrupt("return", res);

                case 5:
                case "end":
                  return _context45.stop();
              }
            }
          }, _callee45);
        }))();
      },
      updateView: function updateView(context, viewData) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee46() {
          var res, targetCode, targetView;
          return _regenerator["default"].wrap(function _callee46$(_context46) {
            while (1) {
              switch (_context46.prev = _context46.next) {
                case 0:
                  _context46.next = 2;
                  return context.service.updateView(viewData);

                case 2:
                  res = _context46.sent;

                  if (!res.errorCode) {
                    targetCode = viewData.viewCode;
                    targetView = context.state.views.find(function (view) {
                      return view.viewCode === targetCode;
                    });

                    if (targetView) {
                      Object.assign(targetView, viewData);
                    }
                  }

                  return _context46.abrupt("return", res);

                case 5:
                case "end":
                  return _context46.stop();
              }
            }
          }, _callee46);
        }))();
      },
      deleteView: function deleteView(context, viewCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee47() {
          var schemaCode, res, targetIndex;
          return _regenerator["default"].wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  schemaCode = context.state.code;
                  _context47.next = 3;
                  return context.service.deleteView(schemaCode, viewCode);

                case 3:
                  res = _context47.sent;

                  if (!res.errorCode) {
                    targetIndex = context.state.views.findIndex(function (view) {
                      return view.code === viewCode;
                    });
                    context.state.views.splice(targetIndex, 1);
                  }

                  return _context47.abrupt("return", res);

                case 6:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47);
        }))();
      },
      getPreference: function getPreference(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee48() {
          var memberId, schemaCode, res;
          return _regenerator["default"].wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  memberId = context.scope.EngineContext.memberId;
                  schemaCode = context.state.code;
                  _context48.next = 4;
                  return context.service.getPreference(schemaCode, memberId);

                case 4:
                  res = _context48.sent;

                  if (res && !res.errorCode) {
                    context.state.preference = convertPreferenceToObject(res.data);
                  }

                  return _context48.abrupt("return", res);

                case 7:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48);
        }))();
      },
      updatePreference: function updatePreference(context, settings) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee49() {
          var key, value, restSettings, realSettings, _Object$assign, memberId, viewCode, res;

          return _regenerator["default"].wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  key = settings.key, value = settings.value, restSettings = (0, _objectWithoutPropertiesLoose2["default"])(settings, ["key", "value"]);
                  realSettings = restSettings || {};

                  if (key && value !== undefined) {
                    realSettings = Object.assign(realSettings, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign)); // 做旧的接口的兼容
                  }

                  memberId = context.scope.EngineContext.memberId;
                  viewCode = context.state.code;
                  _context49.next = 7;
                  return context.service.updateMultiPreference(viewCode, memberId, convertPreferenceToJsonStr(realSettings));

                case 7:
                  res = _context49.sent;

                  if (res && !res.errorCode) {
                    context.state.preference = Object.assign(context.state.preference || {}, realSettings);

                    if (realSettings.viewSorts) {
                      context.state.views = sortViewByPreference(context.state.views, realSettings.viewSorts);
                    }
                  }

                  return _context49.abrupt("return", res);

                case 10:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49);
        }))();
      },
      updateViewScopeType: function updateViewScopeType(context, params) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee50() {
          var viewCode, newType, view, _view$data, type, settings, schemaCode, belongTo, mode, displayName, memberId, updateViewType, res, _index3, targetViewRes;

          return _regenerator["default"].wrap(function _callee50$(_context50) {
            while (1) {
              switch (_context50.prev = _context50.next) {
                case 0:
                  viewCode = params.viewCode, newType = params.newType;
                  _context50.next = 3;
                  return context.getViewByCode(viewCode);

                case 3:
                  view = _context50.sent;

                  if (view) {
                    _context50.next = 6;
                    break;
                  }

                  return _context50.abrupt("return", {
                    errorCode: '视图不存在',
                    data: null
                  });

                case 6:
                  _view$data = view.data, type = _view$data.type, settings = _view$data.settings, schemaCode = _view$data.schemaCode, belongTo = _view$data.belongTo, mode = _view$data.mode, displayName = _view$data.displayName;

                  if (!(newType === type)) {
                    _context50.next = 9;
                    break;
                  }

                  return _context50.abrupt("return", {
                    errorCode: '不需要更新视图类型',
                    data: null
                  });

                case 9:
                  // 视图公开类型更新逻辑
                  // 1.由personal-public 或者 personal-locked, 迁移preference到viewsetting后删除preference
                  // 2.由public - personal 或者 locked-personal，迁移viewsetting 到 preference后删除 viewsetting;
                  memberId = context.scope.EngineContext.memberId;

                  updateViewType = function updateViewType() {
                    var targetView = context.state.views.find(function (_view) {
                      return _view.viewCode === viewCode;
                    });

                    if (targetView) {
                      Object.assign(targetView, {
                        type: newType
                      });
                    }
                  };

                  _context50.next = 13;
                  return context.service.updateView({
                    type: newType,
                    viewCode: viewCode,
                    schemaCode: schemaCode,
                    belongTo: belongTo,
                    mode: mode,
                    displayName: displayName
                  });

                case 13:
                  res = _context50.sent;

                  if (!(res && !res.errorCode)) {
                    _context50.next = 33;
                    break;
                  }

                  if (!(newType === ViewScopeType.PERSONAL)) {
                    _context50.next = 22;
                    break;
                  }

                  _context50.next = 18;
                  return context.service.updateMultiPreference(viewCode, belongTo, settings);

                case 18:
                  res = _context50.sent;

                  if (belongTo !== memberId) {
                    _index3 = context.state.views.findIndex(function (_view) {
                      return _view.viewCode === viewCode;
                    });

                    if (_index3 > -1) {
                      context.state.views.splice(_index3, 1);
                    }
                  } else {
                    updateViewType();
                  }

                  _context50.next = 32;
                  break;

                case 22:
                  updateViewType();
                  _context50.next = 25;
                  return getViewSetting(viewCode, context.scope.EngineContext.memberId, context.scope);

                case 25:
                  targetViewRes = _context50.sent;

                  if (targetViewRes.data) {
                    _context50.next = 28;
                    break;
                  }

                  return _context50.abrupt("return", targetViewRes);

                case 28:
                  if (isEmptyObj(targetViewRes.data.settings)) {
                    _context50.next = 32;
                    break;
                  }

                  _context50.next = 31;
                  return context.scope.ViewContext.updateViewConfig(targetViewRes.data.settings);

                case 31:
                  res = _context50.sent;

                case 32:
                  return _context50.abrupt("return", res);

                case 33:
                case "end":
                  return _context50.stop();
              }
            }
          }, _callee50);
        }))();
      },
      updateSharedState: function updateSharedState(context, sharedState) {
        context.state.tag = sharedState;
        context.state.type = SchemaType.SharedSchema;
      },
      setActiveView: function setActiveView(context, viewCode) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee51() {
          var ret;
          return _regenerator["default"].wrap(function _callee51$(_context51) {
            while (1) {
              switch (_context51.prev = _context51.next) {
                case 0:
                  _context51.next = 2;
                  return context.scope.ViewContext.load(viewCode);

                case 2:
                  ret = _context51.sent;
                  return _context51.abrupt("return", ret);

                case 4:
                case "end":
                  return _context51.stop();
              }
            }
          }, _callee51);
        }))();
      },
      getActiveView: function getActiveView(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee52() {
          return _regenerator["default"].wrap(function _callee52$(_context52) {
            while (1) {
              switch (_context52.prev = _context52.next) {
                case 0:
                  return _context52.abrupt("return", context.scope.ViewContext);

                case 1:
                case "end":
                  return _context52.stop();
              }
            }
          }, _callee52);
        }))();
      }
    }
  };
  _exports.SchemaContextImpl = schema_context;

  function sortViewByPreference(views, viewSorts) {
    // eslint-disable-next-line no-param-reassign
    viewSorts = Array.isArray(viewSorts) ? viewSorts : [];
    return views.sort(function (prev, next) {
      var prevIndex = viewSorts.findIndex(function (code) {
        return code === prev.viewCode;
      });
      var nextIndex = viewSorts.findIndex(function (code) {
        return code === next.viewCode;
      });
      prevIndex = prevIndex < 0 ? Infinity : prevIndex;
      nextIndex = nextIndex < 0 ? Infinity : nextIndex;
      return prevIndex - nextIndex;
    });
  }

  var user_context = {
    name: 'UserContext',
    domain: 'User',
    state: {},
    actions: {
      load: function load(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee53() {
          return _regenerator["default"].wrap(function _callee53$(_context53) {
            while (1) {
              switch (_context53.prev = _context53.next) {
                case 0:
                  _context53.next = 2;
                  return context.getEngines();

                case 2:
                  return _context53.abrupt("return", {
                    data: context.getValue()
                  });

                case 3:
                case "end":
                  return _context53.stop();
              }
            }
          }, _callee53);
        }))();
      },
      updateUserInfo: function updateUserInfo(_ref8, data) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee54() {
          var service, state, res;
          return _regenerator["default"].wrap(function _callee54$(_context54) {
            while (1) {
              switch (_context54.prev = _context54.next) {
                case 0:
                  service = _ref8.service, state = _ref8.state;
                  _context54.next = 3;
                  return service.updateUserInfo({
                    userName: data.userName,
                    personalSignature: data.userDescription,
                    avatarUrl: data.userAvatarUrl
                  });

                case 3:
                  res = _context54.sent;

                  if (res && !res.errorCode) {
                    data.userName !== undefined && (state.userName = data.userName);
                    data.userDescription !== undefined && (state.userDescription = data.userDescription);
                    data.userAvatarUrl !== undefined && (state.userAvatarUrl = data.userAvatarUrl);
                  }

                  return _context54.abrupt("return", res);

                case 6:
                case "end":
                  return _context54.stop();
              }
            }
          }, _callee54);
        }))();
      },
      getEngines: function getEngines(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee55() {
          var userRes;
          return _regenerator["default"].wrap(function _callee55$(_context55) {
            while (1) {
              switch (_context55.prev = _context55.next) {
                case 0:
                  _context55.next = 2;
                  return context.service.getUserEngine();

                case 2:
                  userRes = _context55.sent;

                  if (!userRes.errorCode && userRes.data) {
                    context.state.engines = userRes.data.corpIntegrateEngineAO;
                    context.state.userId = userRes.data.userId;
                  }

                  if (userRes.errorCode === 'corp.integrate.user.org.empty') {
                    context.state.engines = [];
                  }

                  return _context55.abrupt("return", {
                    data: context.state.engines || []
                  });

                case 6:
                case "end":
                  return _context55.stop();
              }
            }
          }, _callee55);
        }))();
      },
      getUserInfo: function getUserInfo(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee56() {
          var scope, state, res, member;
          return _regenerator["default"].wrap(function _callee56$(_context56) {
            while (1) {
              switch (_context56.prev = _context56.next) {
                case 0:
                  scope = context.scope, state = context.state;
                  _context56.next = 3;
                  return scope.EngineContext.service.getMemberInfo(scope.EngineContext.memberId);

                case 3:
                  res = _context56.sent;

                  if (!(res && !res.errorCode)) {
                    _context56.next = 11;
                    break;
                  }

                  member = res.data;
                  state.userAvatarUrl = member.profilePhotoUrl;
                  state.userDescription = member.personalSignature;
                  state.userName = member.name;
                  state.mobile = member.mobile;
                  return _context56.abrupt("return", {
                    data: context.getValue()
                  });

                case 11:
                  return _context56.abrupt("return", {
                    errorCode: res.errorCode,
                    errorMsg: res.errorMsg,
                    errorType: 'BIZ'
                  });

                case 12:
                case "end":
                  return _context56.stop();
              }
            }
          }, _callee56);
        }))();
      }
    }
  };
  _exports.UserContextImpl = user_context;
  var view_context = {
    name: 'ViewContext',
    domain: 'Views',
    state: {},
    actions: {
      load: function load(context, code) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee57() {
          return _regenerator["default"].wrap(function _callee57$(_context57) {
            while (1) {
              switch (_context57.prev = _context57.next) {
                case 0:
                  context.state.code = code;
                  context.state.viewCode = code;
                  context.state.schemaCode = context.scope.SchemaContext.code;
                  context.state.appCode = context.scope.AppContext.code;
                  context.state.settings = {};
                  _context57.next = 7;
                  return context.getViewConfig();

                case 7:
                  return _context57.abrupt("return", {
                    data: context.getValue()
                  });

                case 8:
                case "end":
                  return _context57.stop();
              }
            }
          }, _callee57);
        }))();
      },
      getViewConfig: function getViewConfig(context) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee58() {
          return _regenerator["default"].wrap(function _callee58$(_context58) {
            while (1) {
              switch (_context58.prev = _context58.next) {
                case 0:
                  return _context58.abrupt("return", getViewSetting$1(context));

                case 1:
                case "end":
                  return _context58.stop();
              }
            }
          }, _callee58);
        }))();
      },
      updateViewConfig: function updateViewConfig(context, settings) {
        return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee59() {
          return _regenerator["default"].wrap(function _callee59$(_context59) {
            while (1) {
              switch (_context59.prev = _context59.next) {
                case 0:
                  return _context59.abrupt("return", updateViewSetting(context, settings));

                case 1:
                case "end":
                  return _context59.stop();
              }
            }
          }, _callee59);
        }))();
      }
    }
  }; // 获取公开的viewsetting

  _exports.ViewContextImpl = view_context;

  function getPublicViewSetting$1(_x9) {
    return _getPublicViewSetting$.apply(this, arguments);
  }

  function _getPublicViewSetting$() {
    _getPublicViewSetting$ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee62(context) {
      var viewCode, res;
      return _regenerator["default"].wrap(function _callee62$(_context62) {
        while (1) {
          switch (_context62.prev = _context62.next) {
            case 0:
              viewCode = context.state.code;

              if (!(viewCode === 'default')) {
                _context62.next = 7;
                break;
              }

              _context62.next = 4;
              return context.service.getDefaultView(context.state.schemaCode);

            case 4:
              res = _context62.sent;
              _context62.next = 10;
              break;

            case 7:
              _context62.next = 9;
              return context.scope.SchemaContext.getViewByCode(viewCode);

            case 9:
              res = _context62.sent;

            case 10:
              if (!(res && res.data && !res.errorCode)) {
                _context62.next = 17;
                break;
              }

              context.state.layout = res.data.layout;
              context.state.displayName = res.data.displayName;
              context.state.mode = res.data.mode;
              context.state.type = res.data.type;
              context.state.belongTo = res.data.belongTo;
              return _context62.abrupt("return", {
                data: res.data.settings
              });

            case 17:
              return _context62.abrupt("return", res);

            case 18:
            case "end":
              return _context62.stop();
          }
        }
      }, _callee62);
    }));
    return _getPublicViewSetting$.apply(this, arguments);
  }

  function getPreference$1(_x10) {
    return _getPreference$.apply(this, arguments);
  } // 带业务的获取视图配置（管理员直接获取全局视图配置， 非管理员获取个性化配置）


  function _getPreference$() {
    _getPreference$ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee63(context) {
      var viewCode, memberId, res, result;
      return _regenerator["default"].wrap(function _callee63$(_context63) {
        while (1) {
          switch (_context63.prev = _context63.next) {
            case 0:
              viewCode = context.state.code;
              memberId = context.scope.EngineContext.memberId;
              _context63.next = 4;
              return context.service.getPreference(viewCode, memberId);

            case 4:
              res = _context63.sent;

              if (!(res && !res.errorCode)) {
                _context63.next = 9;
                break;
              }

              result = convertPreferenceToObject(res.data || {}); // const result = res.data || {};

              context.state.settings = result;
              return _context63.abrupt("return", {
                data: result
              });

            case 9:
              return _context63.abrupt("return", {
                errorCode: 'viewType not exists',
                data: null
              });

            case 10:
            case "end":
              return _context63.stop();
          }
        }
      }, _callee63);
    }));
    return _getPreference$.apply(this, arguments);
  }

  function getViewSetting$1(_x11) {
    return _getViewSetting$.apply(this, arguments);
  } // 更新个人偏好


  function _getViewSetting$() {
    _getViewSetting$ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee64(context) {
      var viewCode, view, type, superRole, ret;
      return _regenerator["default"].wrap(function _callee64$(_context64) {
        while (1) {
          switch (_context64.prev = _context64.next) {
            case 0:
              // 首先判断视图的公开类型
              // console.log('__context.scope__', context.scope);
              viewCode = context.state.code; // const viewCode = context.scope.ViewContext.viewCode;

              _context64.next = 3;
              return context.scope.SchemaContext.getViewByCode(viewCode);

            case 3:
              view = _context64.sent;

              if (!view.errorCode) {
                _context64.next = 6;
                break;
              }

              return _context64.abrupt("return", view);

            case 6:
              if (!(context.state.settings && !isEmptyObj(context.state.settings))) {
                _context64.next = 8;
                break;
              }

              return _context64.abrupt("return", {
                data: context.state.settings
              });

            case 8:
              type = view.data.type;

              if (!(type === ViewScopeType.PUBLIC || type === ViewScopeType.LOCKED)) {
                _context64.next = 23;
                break;
              }

              // 这里普通用户可能会多存在preference, 管理员只存viewsetting,且只从viewsetting取
              superRole = context.scope.AppContext.mySuperRole;

              if (!(superRole === AppPermissionEnum.MANAGER || superRole === AppPermissionEnum.OWNER || type === ViewScopeType.LOCKED)) {
                _context64.next = 15;
                break;
              }

              return _context64.abrupt("return", getPublicViewSetting$1(context));

            case 15:
              _context64.next = 17;
              return getPreference$1(context);

            case 17:
              ret = _context64.sent;

              if (!(!ret.errorCode && (!ret.data || isEmptyObj(ret.data)))) {
                _context64.next = 20;
                break;
              }

              return _context64.abrupt("return", getPublicViewSetting$1(context));

            case 20:
              return _context64.abrupt("return", ret);

            case 21:
              _context64.next = 25;
              break;

            case 23:
              if (!(type === ViewScopeType.PERSONAL)) {
                _context64.next = 25;
                break;
              }

              return _context64.abrupt("return", getPreference$1(context));

            case 25:
              return _context64.abrupt("return", {
                errorCode: 'viewType not exists',
                data: null
              });

            case 26:
            case "end":
              return _context64.stop();
          }
        }
      }, _callee64);
    }));
    return _getViewSetting$.apply(this, arguments);
  }

  function updatePreference(_x12, _x13) {
    return _updatePreference.apply(this, arguments);
  } // 更新视图公共配置


  function _updatePreference() {
    _updatePreference = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee65(context, settings) {
      var key, value, restSettings, realSettings, _Object$assign2, memberId, viewCode, scope, ret, res;

      return _regenerator["default"].wrap(function _callee65$(_context65) {
        while (1) {
          switch (_context65.prev = _context65.next) {
            case 0:
              key = settings.key, value = settings.value, restSettings = (0, _objectWithoutPropertiesLoose2["default"])(settings, ["key", "value"]);
              realSettings = restSettings || {};

              if (key && value !== undefined) {
                realSettings = Object.assign(realSettings, (_Object$assign2 = {}, _Object$assign2[key] = value, _Object$assign2)); // 做旧的接口的兼容
              }

              memberId = context.scope.EngineContext.memberId;
              viewCode = context.state.code;
              scope = memberId;

              if (!(!context.state.settings || isEmptyObj(context.state.settings))) {
                _context65.next = 17;
                break;
              }

              if (!(viewCode === 'default')) {
                _context65.next = 13;
                break;
              }

              _context65.next = 10;
              return context.service.getDefaultView(context.state.schemaCode);

            case 10:
              ret = _context65.sent;
              _context65.next = 16;
              break;

            case 13:
              _context65.next = 15;
              return context.scope.SchemaContext.getViewByCode(viewCode);

            case 15:
              ret = _context65.sent;

            case 16:
              realSettings = Object.assign(ret.data.settings, realSettings);

            case 17:
              _context65.next = 19;
              return context.service.updateMultiPreference(viewCode, scope, realSettings);

            case 19:
              res = _context65.sent;

              if (res && !res.errorCode) {
                context.state.settings = Object.assign(context.state.settings || {}, realSettings);
              }

              return _context65.abrupt("return", res);

            case 22:
            case "end":
              return _context65.stop();
          }
        }
      }, _callee65);
    }));
    return _updatePreference.apply(this, arguments);
  }

  function updatePublicViewSetting(_x14, _x15) {
    return _updatePublicViewSetting.apply(this, arguments);
  } // 更新视图配置，注意preference的scope一定为memberId, 去掉了scope为viewcode的情况


  function _updatePublicViewSetting() {
    _updatePublicViewSetting = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee66(context, settings) {
      var viewCode, memberId, res, _res, schema, targetView;

      return _regenerator["default"].wrap(function _callee66$(_context66) {
        while (1) {
          switch (_context66.prev = _context66.next) {
            case 0:
              viewCode = context.state.code;
              memberId = context.scope.EngineContext.memberId;
              _context66.next = 4;
              return context.service.removeUserPreference(viewCode, memberId);

            case 4:
              res = _context66.sent;

              if (!(res && res.data && !res.errorCode)) {
                _context66.next = 13;
                break;
              }

              if (!(context.state.code === 'default')) {
                _context66.next = 8;
                break;
              }

              return _context66.abrupt("return", {
                data: true
              });

            case 8:
              _context66.next = 10;
              return context.service.updateViewConfig(viewCode, settings);

            case 10:
              _res = _context66.sent;

              if (_res && !_res.errorCode) {
                schema = context.rootState.Schemas[context.state.schemaCode];

                if (schema && schema.views && schema.views.length > 0) {
                  targetView = schema.views.find(function (viewItem) {
                    return viewItem.viewCode === viewCode;
                  });

                  if (targetView) {
                    targetView.settings = Object.assign(targetView.settings || {}, settings);
                  }
                }
              }

              return _context66.abrupt("return", _res);

            case 13:
            case "end":
              return _context66.stop();
          }
        }
      }, _callee66);
    }));
    return _updatePublicViewSetting.apply(this, arguments);
  }

  function updateViewSetting(_x16, _x17) {
    return _updateViewSetting.apply(this, arguments);
  }
  /**
   * @packageDocumentation
   * @module domain
   */


  function _updateViewSetting() {
    _updateViewSetting = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee67(context, settings) {
      var viewCode, view, _ref9, type, superRole;

      return _regenerator["default"].wrap(function _callee67$(_context67) {
        while (1) {
          switch (_context67.prev = _context67.next) {
            case 0:
              // 如果视图公开类型为personal，则一定存储为preference, 存储时先删除viewsetting
              // 如果视图公开类型为public或locked, 则区分管理员和普通用户
              // 公开视图普通用户存储时，存储为preference
              // 公开视图管理员存储时， 先删除preference， 然后存储viewsetting
              viewCode = context.state.code;
              _context67.next = 3;
              return context.scope.SchemaContext.getViewByCode(viewCode);

            case 3:
              view = _context67.sent;
              _ref9 = view.data || {}, type = _ref9.type;
              superRole = context.scope.AppContext.mySuperRole;

              if (!((superRole === AppPermissionEnum.MANAGER || superRole === AppPermissionEnum.OWNER) && (type === ViewScopeType.PUBLIC || type === ViewScopeType.LOCKED))) {
                _context67.next = 8;
                break;
              }

              return _context67.abrupt("return", updatePublicViewSetting(context, settings));

            case 8:
              return _context67.abrupt("return", updatePreference(context, settings));

            case 9:
            case "end":
              return _context67.stop();
          }
        }
      }, _callee67);
    }));
    return _updateViewSetting.apply(this, arguments);
  }

  var DomainContextMap = {
    UserContext: '',
    EngineContext: '',
    AppContext: '',
    SchemaContext: '',
    ViewContext: ''
  };
  _exports.DomainContextMap = DomainContextMap;
  var DomainStoreMap = {
    User: 'User',
    Engine: 'Engine',
    Apps: 'Apps',
    Schemas: 'Schemas',
    Views: 'Views'
  };
  _exports.DomainStoreMap = DomainStoreMap;
  var domainDefinitionMap = {
    User: userDefinition,
    Engine: engineDefinition,
    Apps: appDefinition,
    Schemas: schemaDefinition,
    Views: viewDefinition
  };
  _exports.domainDefinitionMap = domainDefinitionMap;
});
